import { Component, OnInit, Input, ChangeDetectionStrategy, ViewChild } from '@angular/core'
import { TrackSale } from 'src/app/models/track-sale.model'
import { environment } from 'src/environments/environment'
import { MatBottomSheet } from '@angular/material/bottom-sheet'
import { Store } from '@ngrx/store'
import { AppState } from 'src/app/reducers'

@Component({
    selector: 'app-sp-track-sale',
    changeDetection: ChangeDetectionStrategy.OnPush,
    template: `
    <mat-card>
      <mat-card-content>
        @if (!loading && !trackSale.title) {
          <div
            class="no-product"
            fxLayout
            fxLayoutAlign="center center"
            >
            リリース済みの作品はありません。
          </div>
        }
    
        @if (loading || trackSale.title) {
          <div
            fxLayout="column"
            fxFlex="100%"
            fxLayoutAlign="space-evenly start"
            fxLayoutGap="16px"
            >
            <div class="trend" fxLayout="row">
              <div fxFlex="1 1 auto" fxLayout="column" fxLayoutGap="16px">
                <div>
                  @if (!loading) {
                    <span class="title">{{ trackSale.title }}</span>
                  }
                </div>
              </div>
            </div>
            <div class="data-field">
              <app-sp-data-field legend="売上（NET）" fxFlex="1 1 100%">
                <div
                  class="trend-item"
                  fxLayout="row wrap"
                  fxLayoutAlign="end baseline"
                  fxLayoutGap="8px"
                  >
                  @if (!loading) {
                    <div class="trend-item-amount value">
                      {{ trackSale.salesCurrencyAmount | number }}
                      <span>&nbsp;</span>
                    </div>
                    <div fxLayout fxLayoutAlign="start center">
                      @if (trackSale.salesCurrencyAmountRate !== null) {
                        <div class="item-percent">
                          {{ trackSale.salesCurrencyAmountRate | number: '1.0-0' }}%
                        </div>
                        @if (trackSale.salesCurrencyAmountRate > 100) {
                          <mat-icon>trending_up</mat-icon>
                        }
                        @if (trackSale.salesCurrencyAmountRate < 100) {
                          <mat-icon
                            >trending_down</mat-icon
                            >
                          }
                          @if (trackSale.salesCurrencyAmountRate == 100) {
                            <mat-icon></mat-icon>
                          }
                        } @else {
                          <div>- %</div>
                        }
                      </div>
                    } @else {
                      <app-music-note></app-music-note>
                    }
                  </div>
                </app-sp-data-field>
              </div>
              <div class="data-field">
                <app-sp-data-field legend="アルバム換算数" fxFlex="1 1 100%">
                  <div
                    class="trend-item"
                    fxLayout="row wrap"
                    fxLayoutAlign="end baseline"
                    fxLayoutGap="8px"
                    >
                    @if (!loading) {
                      <div class="trend-item-amount value">
                        {{ trackSale.trackAdjustedUnits | number }}
                        <span>&nbsp;</span>
                      </div>
                      <div fxLayout fxLayoutAlign="start center">
                        @if (trackSale.trackAdjustedUnitsRate !== null) {
                          <div class="item-percent">
                            {{ trackSale.trackAdjustedUnitsRate | number: '1.0-0' }}%
                          </div>
                          @if (trackSale.trackAdjustedUnitsRate > 100) {
                            <mat-icon>trending_up</mat-icon>
                          }
                          @if (trackSale.trackAdjustedUnitsRate < 100) {
                            <mat-icon
                              >trending_down</mat-icon
                              >
                            }
                            @if (trackSale.trackAdjustedUnitsRate == 100) {
                              <mat-icon></mat-icon>
                            }
                          } @else {
                            <div>- %</div>
                          }
                        </div>
                      } @else {
                        <app-music-note></app-music-note>
                      }
                    </div>
                  </app-sp-data-field>
                </div>
                <div class="data-field">
                  <app-sp-data-field legend="トラックダウンロード数" fxFlex="1 1 100%">
                    <div
                      class="trend-item"
                      fxLayout="row wrap"
                      fxLayoutAlign="end baseline"
                      fxLayoutGap="8px"
                      >
                      @if (!loading) {
                        <div class="trend-item-amount value">
                          {{ trackSale.trackDownloads | number }}
                          <span>&nbsp;</span>
                        </div>
                        <div fxLayout fxLayoutAlign="start center">
                          @if (trackSale.trackDownloadsRate !== null) {
                            <div class="item-percent">
                              {{ trackSale.trackDownloadsRate | number: '1.0-0' }}%
                            </div>
                            @if (trackSale.trackDownloadsRate > 100) {
                              <mat-icon>trending_up</mat-icon>
                            }
                            @if (trackSale.trackDownloadsRate < 100) {
                              <mat-icon>trending_down</mat-icon>
                            }
                            @if (trackSale.trackDownloadsRate == 100) {
                              <mat-icon></mat-icon>
                            }
                          } @else {
                            <div>- %</div>
                          }
                        </div>
                      } @else {
                        <app-music-note></app-music-note>
                      }
                    </div>
                  </app-sp-data-field>
                </div>
                <div class="data-field">
                  <app-sp-data-field legend="ストリーム数" fxFlex="1 1 100%">
                    <div
                      class="trend-item"
                      fxLayout="row wrap"
                      fxLayoutAlign="end baseline"
                      fxLayoutGap="8px"
                      >
                      @if (!loading) {
                        <div class="trend-item-amount value">
                          {{ trackSale.streams | number }}
                          <span>&nbsp;</span>
                        </div>
                        <div fxLayout fxLayoutAlign="start center">
                          @if (trackSale.streamsRate !== null) {
                            <div class="item-percent">{{ trackSale.streamsRate | number: '1.0-0' }}%</div>
                            @if (trackSale.streamsRate > 100) {
                              <mat-icon>trending_up</mat-icon>
                            }
                            @if (trackSale.streamsRate < 100) {
                              <mat-icon>trending_down</mat-icon>
                            }
                            @if (trackSale.streamsRate == 100) {
                              <mat-icon></mat-icon>
                            }
                          } @else {
                            <div>- %</div>
                          }
                        </div>
                      } @else {
                        <app-music-note></app-music-note>
                      }
                    </div>
                  </app-sp-data-field>
                </div>
              </div>
            }
          </mat-card-content>
        </mat-card>
    
    
    `,
    styleUrls: ['./sp-track-sale.component.scss'],
    standalone: false
})
export class SpTrackSaleComponent implements OnInit {
  @Input()
  trackSale: TrackSale

  @Input()
  loading = true

  constructor(private store: Store<AppState>, private bottomSheet: MatBottomSheet) {}

  ngOnInit() {}
}
